import { render, staticRenderFns } from "./backsearch-view.vue?vue&type=template&id=3c00b564&scoped=true"
import script from "./backsearch-view.vue?vue&type=script&lang=js"
export * from "./backsearch-view.vue?vue&type=script&lang=js"
import style0 from "./backsearch-view.vue?vue&type=style&index=0&id=3c00b564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c00b564",
  null
  
)

export default component.exports